// src/components/HeaderMenu/HeaderMenu.jsx

import React, { useState, useEffect } from "react";
import "./HeaderMenu.css";

import ChangePassword from "../UserMaster/ChangePassword";
import StudentHostlerUpdate from "../HostelDetails/StudentHostlerUpdate";
import ExcelUploadDialog from "../DataUpload/ExcelUploadDialog";

import axiosApi from "../Utils/axiosApi";
import { SITE_CONFIG } from "../../config/siteConfig";
const HeaderMenu = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState({});
  const [userName, setUserName] = useState("");

  // Dynamic Menu From API
  const [menuItems, setMenuItems] = useState({});

  // Change Password Popup
  const [openChangePassword, setOpenChangePassword] = useState(false);

  // Student Popup
  const [openStudentPopup, setOpenStudentPopup] = useState(false);
  const [loggedHosteler, setLoggedHosteler] = useState(null);

  // Excel Popup
  const [openExcelPopup, setOpenExcelPopup] = useState(false);

  // ===============================
  // LOAD MENU FROM API
  // ===============================
  useEffect(() => {

  const storedUserName =
    sessionStorage.getItem("userName");

  setUserName(storedUserName);

  // ===============================
  // LOAD MENU FROM SESSION STORAGE
  // ===============================

  const storedMenus =
    sessionStorage.getItem("menuItems");
  if (!storedMenus) {

    window.location.href = "/";

    return;
  }

  const menuResponse =
    JSON.parse(storedMenus);

  // ===============================
  // CONVERT MENU FORMAT
  // ===============================

  const formattedMenu = {};

  menuResponse.forEach((item) => {

    const mainMenu = item.mainMenu;
    const subMenu = item.subMenu;
    const menuUrl = item.menuUrl;

    // MAIN MENU
    if (!subMenu || subMenu === "") {

      formattedMenu[mainMenu] = menuUrl;

    } else {

      // SUB MENU
      if (!formattedMenu[mainMenu]) {

        formattedMenu[mainMenu] = {};
      }

      formattedMenu[mainMenu][subMenu] = menuUrl;
    }
  });

  setMenuItems(formattedMenu);

}, []);
  // ===============================
  // MENU TOGGLE
  // ===============================

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

 const toggleSubmenu = (index) => {
  setSubmenuOpen((prev) => ({
    ...prev,
    [index]: !prev[index],
  }));
};

  // ===============================
  // CHANGE PASSWORD
  // ===============================

  const handleOpenChangePassword = () => {
    setOpenChangePassword(true);
  };

  const handleCloseChangePassword = () => {
    setOpenChangePassword(false);
  };

  // ===============================
  // HOSTELER PROFILE POPUP
  // ===============================

  const handleOpenStudentPopup = async () => {
    try {
      const userId = sessionStorage.getItem("userId");

      if (!userId) return;

      const response = await axiosApi.post("/hosteler/getHosteler", {
        userIds: [userId],
      });

      if (Array.isArray(response.data) && response.data.length > 0) {
        setLoggedHosteler(response.data[0]);
      } else {
        alert("No hosteler data found");
        return;
      }

      setOpenStudentPopup(true);
    } catch (err) {
      alert("Failed to load profile");
    }
  };

  const handleCloseStudentPopup = () => {
    setOpenStudentPopup(false);
  };

  // ===============================
  // EXCEL POPUP
  // ===============================

  const handleOpenExcelPopup = () => {
    setOpenExcelPopup(true);
  };

  const handleCloseExcelPopup = () => {
    setOpenExcelPopup(false);
  };

  // ===============================
  // LOGOUT
  // ===============================

 const handleLogout = () => {
  const siteKey = SITE_CONFIG.key;
  sessionStorage.clear();

  const hostname = window.location.hostname.toLowerCase();

  // Local development
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    window.location.href = `/?site=${siteKey}`;
    return;
  }

  // Production
  window.location.href = `${SITE_CONFIG.canonicalBase}/`;
};
  return (
    <header className="header">
      <div className="menu-toggle" onClick={toggleMenu}>
        &#9776;
      </div>

      <nav className={`main-menu ${menuOpen ? "open" : ""}`}>
        <ul>
          {Object.entries(menuItems).map(([menu, value], index) => (
            <li key={menu} className="menu-item">

              {/* POPUP MENU */}
              {value === "POPUP" ? (
                <button
                  className="menu-button-link"
                  onClick={handleOpenStudentPopup}
                >
                  {menu}
                </button>
              ) : value === "EXCEL_POPUP" ? (
                <button
                  className="menu-button-link"
                  onClick={handleOpenExcelPopup}
                >
                  {menu}
                </button>
              ) : typeof value === "string" ? (

                // DIRECT MENU
                <a href={value}>{menu}</a>

              ) : (

                // SUB MENU
                <>
                  <button
                    className="menu-button-link"
                    onClick={() => toggleSubmenu(index)}
                  >
                    {menu}
                  </button>

                  {submenuOpen[index] && (
                    <ul className="submenu">
                      {Object.entries(value).map(([submenu, link]) => (
                        <li key={submenu}>
                          {link === "EXCEL_POPUP" ? (
                            <button
                              className="submenu-button-link"
                              onClick={handleOpenExcelPopup}
                            >
                              {submenu}
                            </button>
                          ) : link === "POPUP" ? (
                            <button
                              className="submenu-button-link"
                              onClick={handleOpenStudentPopup}
                            >
                              {submenu}
                            </button>
                          ) : (
                            <a href={link}>{submenu}</a>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              )}
            </li>
          ))}

          {/* CHANGE PASSWORD */}
          <li>
            <button
              className="menu-button-link"
              onClick={handleOpenChangePassword}
            >
              Change Password
            </button>
          </li>

          {/* LOGOUT */}
          <li>
            <button
              className="menu-button-link"
              onClick={handleLogout}
            >
              Logout
            </button>
          </li>

          {/* USER NAME */}
          <li className="username-item">
            {userName && (
              <span className="username">
                Welcome, {userName}
              </span>
            )}
          </li>
        </ul>
      </nav>

      {/* CHANGE PASSWORD */}
      <ChangePassword
        open={openChangePassword}
        onClose={handleCloseChangePassword}
      />

      {/* HOSTELER PROFILE */}
      <StudentHostlerUpdate
        open={openStudentPopup}
        onClose={handleCloseStudentPopup}
        hosteler={loggedHosteler}
      />

      {/* EXCEL UPLOAD */}
      <ExcelUploadDialog
        open={openExcelPopup}
        onClose={handleCloseExcelPopup}
      />
    </header>
  );
};

export default HeaderMenu;